import moment from "moment";

export const hasVal = (v) =>
  v !== undefined && v !== null && String(v).trim() !== "";

// Status diturunkan dari data, tanpa flag isDiketahui/isDiterima/isDiVerifikasi
//  - Open               : belum ada penerima
//  - Sedang di Proses   : sudah ada penerima, belum diketahui
//  - Selesai            : sudah ada penerima dan sudah diketahui (masuk Done)
export const getLkmStatus = (d) => {
  if (!d) return { key: "open", label: "Open" };
  if (!hasVal(d.penerima)) return { key: "open", label: "Open" };
  if (!hasVal(d.diketahui)) return { key: "proses", label: "Sedang di Proses" };
  return { key: "done", label: "Selesai" };
};

export const formatNoLkm = (d) =>
  `${String(d.lkmNumber ?? "").padStart(3, "0")}/${d.keBagian}/${moment(
    d.createDate
  ).format("YYYY")}`;

export const formatTgl = (date, format = "DD-MM-YY HH:mm") =>
  date ? moment(date).format(format) : "";
